import React, { useState, useEffect, useRef } from "react";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import axios from "axios";
import "../styles/Modal.scss";

const mdo_types = [{ value: "MAO" }, { value: "MMO" }];
const config = {
  MAO: {
    endpoint: "organizations/api/v1/spots",
    label: "Search spot codes",
    displayKey: "code",
    mdoListParam: "spot_code",
    mdoListKey: "code",
  },
  MMO: {
    endpoint: "route_management/v1/get-routes-for-selection",
    label: "Search routes",
    displayKey: "name",
    mdoListParam: "route",
    mdoListKey: "id",
  },
};

const SpotCodeSearchInput = ({ onSpotCodeSelect, onChangeFieldForceType }) => {
  const [inputValue, setInputValue] = useState("");
  const [spotCodeList, setSpotCodeList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fieldForceType, setFieldForceType] = useState("");
  const [showList, setShowList] = useState(false);
  const cancelToken = useRef(null);
  const [noSpotCodeFound, setNoSpotCodeFound] = useState(false);

  useEffect(() => {
    if (fieldForceType !== "") fetchSpotCodes("");
  }, [fieldForceType]);

  // Custom debounce function to delay API calls
  const debounce = (func, delay) => {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), delay);
    };
  };
  const handleFieldForceTyperChange = (event) => {
    onChangeFieldForceType();
    setShowList(false);
    setInputValue("");
    setFieldForceType(event.target.value);
  };

  const fetchSpotCodes = async (searchTerm) => {
    if (cancelToken.current) {
      // Cancel the previous API request
      cancelToken.current.cancel("Cancelled due to new input");
    }

    // Create a new cancel token
    cancelToken.current = axios.CancelToken.source();

    try {
      setLoading(true);

      // Only send the search term if it's not empty
      const searchQuery = searchTerm ? `search_term=${searchTerm}` : "";
      const pageQuery = "page_index=0&page_size=1000"; // Add the page index and size parameters

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/${config[fieldForceType].endpoint}?${searchQuery}&${pageQuery}`, // Include pageQuery
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
          cancelToken: cancelToken.current.token, // Pass the cancel token
        }
      );

      const spotCodes = response.data.data;
      setSpotCodeList(spotCodes);
      setNoSpotCodeFound(spotCodes.length === 0); // Set noSpotCodeFound state based on the length of the list
      setLoading(false);
      setShowList(true);
    } catch (error) {
      if (axios.isCancel(error)) {
        // Request was cancelled, no need to handle it
      } else {
        console.error("Error fetching spot code list:", error);
      }
      setLoading(false);
    }
  };

  const handleInputChange = (event) => {
    onChangeFieldForceType();
    const newInputValue = event.target.value;
    setShowList(true);
    setInputValue(newInputValue);

    // Use the debounce function to delay API calls
    debouncedFetchSpotCodes(newInputValue);
  };

  const handleSelect = (selectedOption, param) => {
    setInputValue(
      selectedOption ? selectedOption[config[fieldForceType].displayKey] : ""
    );
    onSpotCodeSelect(
      selectedOption ? selectedOption[[config[fieldForceType].mdoListKey]] : "",
      param
    );
  };

  // Debounce the API call with a delay of 300ms
  const debouncedFetchSpotCodes = debounce(fetchSpotCodes, 300);

  // Filter the spot codes based on the beginning of the code
  const filteredSpotCodes = spotCodeList.filter((spotCode) => {
    const spotCodeLowerCase = spotCode[config[fieldForceType].displayKey]
      ? spotCode[config[fieldForceType].displayKey].toLowerCase()
      : "";
    const inputValueLowerCase = inputValue.toLowerCase();
    return spotCodeLowerCase.startsWith(inputValueLowerCase);
  });
  return (
    <div className="assign-ekyc-modal-container">
      <TextField
        id="standard-select-currency"
        select
        label="Select a field force type"
        value={fieldForceType}
        onChange={handleFieldForceTyperChange}
      >
        {mdo_types.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.value}
          </MenuItem>
        ))}
      </TextField>
      <div className="search-spots-routes">
        <label
          htmlFor="search-spot"
          className="search-label"
          style={{ paddingLeft: 8, color: "#e2136e" }}
        >
          {fieldForceType === ""
            ? "No field force type selected"
            : loading
            ? "Searching..."
            : config[fieldForceType].label}
        </label>
        <div className="search-container-spot">
          <TextField
            id="search-spot"
            variant="filled"
            value={inputValue}
            disabled={fieldForceType === ""}
            onChange={handleInputChange}
            className="search-spot"
          />
        </div>

        {showList && (
          <div className="list-container">
            <ul>
              {noSpotCodeFound && (
                <li className="no-spot-code-found">No spot code found</li>
              )}
              {filteredSpotCodes.map((spotCode) => (
                <li
                  key={spotCode.id}
                  onClick={() => {
                    handleSelect(spotCode, config[fieldForceType].mdoListParam);
                    setShowList(false);
                  }}
                  className="spotcode-list-item"
                >
                  {spotCode[config[fieldForceType].displayKey]}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default SpotCodeSearchInput;
